import { render } from "./FloatingDock.vue?vue&type=template&id=23a849af&scoped=true"
import script from "./FloatingDock.vue?vue&type=script&lang=js"
export * from "./FloatingDock.vue?vue&type=script&lang=js"

import "./FloatingDock.vue?vue&type=style&index=0&id=23a849af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a849af"]])

export default __exports__